var _a;
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./template.constants";
export var getDetail = (_a = generateApi(GENERATOR_PARAMS), _a.getDetail), getPaged = _a.getPaged, getCount = _a.getCount, create = _a.create, update = _a.update, remove = _a.remove;
